import React, { useState, useEffect } from 'react';
import { Field, Form, reduxForm } from 'redux-form';
import styles from '../../styles/forms/add_meeting_items_from_template_wizard/AddMeetingItemsFromTemplateForm.scss';
import Button from '../../components/Button';
import { __ } from '../../core/utils';
import Select from '../../components/Select';
import { subscribe } from 'react-contextual/dist/react-contextual.es';
import Localization from '../../helpers/Localization';
import * as _ from 'lodash';
import { withRouter } from 'react-router';
import { listPossibleMeetingTemplates } from '../../redux/actions/table/all_meetings';

const AddMeetingItemsFromTemplateForm = ({
  handleSubmit,
  onClose,
  submitting,
}) => {
  const [list_possible_templates, set_list_possible_templates] = useState([]);

  useEffect(() => {
    listPossibleMeetingTemplates().then(({ response }) => {
      set_list_possible_templates(response.data);
    });
  }, []);

  return (
    <Form onSubmit={handleSubmit} className={styles.wrapper}>
      <div className={styles.form}>
        <div className={styles.f1}>
          <Field
            name='meeting_template_id'
            component={Select}
            noSort
            searchable
            label={__('all_meetings.fields.meeting_template_id')}
            options={list_possible_templates}
          />
        </div>
      </div>
      <div className={styles.footer}>
        <Button
          lightGray
          medium
          left
          middleText={__('button.cancel')}
          onClick={onClose}
        />
        <Button
          lightBlue
          medium
          middleText={__('button.add')}
          spinning={submitting}
          onClick={handleSubmit}
        />
      </div>
    </Form>
  );
};

export default withRouter(
  reduxForm({
    form: 'add_meeting_items_from_template_wizard.add_meeting_items_from_template',
  })(subscribe(Localization, 'localization')(AddMeetingItemsFromTemplateForm))
);
